export const getItemRequest_v1_schema = {
  type: 'string',
};
